import { render } from "./sglm-varnisamiti.vue?vue&type=template&id=a7da9232&scoped=true"
import script from "./sglm-varnisamiti.vue?vue&type=script&lang=js"
export * from "./sglm-varnisamiti.vue?vue&type=script&lang=js"

import "./sglm-varnisamiti.vue?vue&type=style&index=0&id=a7da9232&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7da9232"]])

export default __exports__